class VwKurumicmalDTO {
    id: number = 0;
    organizasyonId?: number = null;
    kurumId?: number = null;
    faturaTarih?: string = null;
    faturaSeri?: string = "";
    faturaNo?: number = null;
    aciklama?: string = "";
    hastasayi?: number = null;
    tutar?: number = null;
    indirimtutar?: number = null;
    faturatutar?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    baslangictarih?: string = null;
    bitistarih?: string = null;
    kdvtutar?: number = null;
    parabirimId?: number = null;
    muhFaturaTarih?: string = null;
    muhFaturaNo?: number = null;
    muhSeriNo?: string = "";
    serino?: string = "";
    kullaniciadsoyadi?: string = "";
    kurumadi?: string = "";
    orgadi?: string = "";
    treekey?: string = "";
    kurumgrupId?: number = null;
    fkSozlesmeTuru?: number = null;
};
export default VwKurumicmalDTO;